$(document).on('click', '.product-recommendations__list .product-recommendations__exit', function () {
  const parent = $(this).parent();
  parent.toggleClass('active');
  parent.find('.product-recommendations-list').stop(true, true).slideToggle(150);
});
$(document).on('click', '.product-recommendations__list .recommendation-wrapper button:not([data-quick-buy-open])', function () {
  $('cart-popup iframe').attr('src', $(this).attr('data-href'));
  document.querySelector('cart-drawer')?.close();
  $('html').css('overflow', 'hidden');
  $('cart-popup').addClass('active loadding');
});
$(document).on('click', 'cart-popup, cart-popup .cart-popup-button', function () {
  if (document.querySelector('cart-popup')?.dataset.busy) return;
  $('html').css('overflow', '');
  $('cart-popup').removeClass('active');
});
$(document).on('click', 'cart-popup .popupBox', event => event.stopPropagation());
window.addEventListener('message', async event => {
  const popup = document.querySelector('cart-popup');
  const frame = popup?.querySelector('iframe');
  if (event.origin !== location.origin || event.source !== frame?.contentWindow || !event.data) return;
  if (event.data.action === 'openCartPopup') $('cart-popup').removeClass('loadding');
  if (event.data.action !== 'closeCartPopup' || popup.dataset.busy) return;
  popup.dataset.busy = 'true';
  try {
    await CartFlow.refresh();
    $('html').css('overflow', '');
    $('cart-popup').removeClass('active');
    document.querySelector('cart-drawer')?.open();
  } catch (error) {
    // The child has already added the item. Navigate to the cart, never retry the add.
    location.assign(CartFlow.url('cart'));
  } finally { delete popup.dataset.busy; }
});
function refreshCartDrawer() { return CartFlow.refresh(); }
